import { memo } from 'react';

import { FormControl, MenuItem, TextField } from '@material-ui/core';

const STAGE_OPTIONS = [
  { id: 'dev', name: 'Development' },
  { id: 'prod', name: 'Production' },
];

type StageSectionProps = {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

export const StageSection = memo(
  ({ value, onChange, disabled }: StageSectionProps) => {
    if (disabled) {
      return (
        <FormControl fullWidth>
          <TextField
            id="stage"
            label="Stage"
            size="small"
            value={value}
            disabled
            inputProps={{ readOnly: true }}
          />
        </FormControl>
      );
    }

    return (
      <FormControl fullWidth required>
        <TextField
          id="stage"
          select
          label="Stage"
          size="small"
          required
          value={value}
          onChange={e => onChange(e.target.value)}
        >
          {STAGE_OPTIONS.map(option => (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
      </FormControl>
    );
  },
);
